import { render, staticRenderFns } from "./employment-record.vue?vue&type=template&id=0cbc3e04&"
import script from "./employment-record.vue?vue&type=script&lang=js&"
export * from "./employment-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports